import { Form, Divider } from "antd";
import React, { Component } from "react";
import validateMessages from "./validateMessages";

class Form2 extends Component {
  formRef = React.createRef();
  isSubmitting = false; // No en estado para evitar re-render innecesario

  getFieldValue(value) {
    return this.formRef.current?.getFieldValue(value);
  }
  getFieldsValue(value) {
    return this.formRef.current?.getFieldsValue(value);
  }
  setFieldsValue(value) {
    return this.formRef.current?.setFieldsValue(value);
  }
  setFields(value) {
    return this.formRef.current?.setFields(value);
  }
  resetFields(value) {
    return this.formRef.current?.resetFields(value);
  }
  validateFields(value) {
    return this.formRef.current?.validateFields(value);
  }
  getFieldsError(value) {
    return this.formRef.current?.getFieldsError(value);
  }
  getFieldError(value) {
    return this.formRef.current?.getFieldError(value);
  }
  getFieldInstance(value) {
    return this.formRef.current?.getFieldInstance(value);
  }
  
  submit() {
    return this.formRef.current?.submit();
  }

  // 🔐 Manejo antirrepetición
  handleFinish = (values) => {
    if (this.isSubmitting) return; // Evita ejecución repetida
    this.isSubmitting = true;

    try {
      if (this.props.onFinish) {
        this.props.onFinish(values); // Ejecuta la función sincrónica
      }
    } catch (err) {
      console.error("Error en onFinish:", err);
    }

    // Libera tras 1.5 segundos (ajustable)
    setTimeout(() => {
      this.isSubmitting = false;
    }, 5000);
  };

  render() {
    let layout;
    if (this.props.layout) {
      layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      };
    } else if (this.props.layoutEspecial) {
      layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      };
    } else {
      layout = null;
    }

    let transformedProperties = {};
    for (var key in this.props) {
      if (
        ![
          "defaultBehavior",
          "layout",
          "layoutEspecial",
          "layoutForm",
          "bottom",
          "onFinish",
        ].includes(key)
      ) {
        transformedProperties[key] = this.props[key];
      }
    }

    return (
      <Form
        layout={this.props.layoutForm}
        ref={this.formRef}
        validateMessages={validateMessages}
        onFinish={this.handleFinish}
        {...transformedProperties}
        {...layout}
        onKeyDown={
          this.props.defaultBehavior
            ? null
            : (e) => {
                if (e.key === "Enter" && e.target.type !== "textarea") {
                  e.preventDefault();
                }
              }
        }
      >
        {this.props.children}
        {this.props.bottom ? (
          <>
            <Divider style={{ margin: 0 }} />
            <div
              style={{ width: "100%", display: "block", padding: "10px 16px" }}
            >
              {this.props.bottom}
            </div>
          </>
        ) : null}
      </Form>
    );
  }
}
Form2.List = Form.List;
Form2.ErrorList = Form.ErrorList;

export default Form2;
